import { lazy } from 'react';
const VerificationPersonal = lazy(() => import('../containers/VerificationPersonalContainer'));
const ProfileVerificationStepHeader = lazy(() =>
  import('../components/ProfileVerificationStepHeader'),
);
const AccountSettings = lazy(() => import('../containers/AccountSettingsContainer'));
const AdditionalIdentityVerification = lazy(() =>
  import('../containers/AdditionalIdentityVerificationContainer'),
);
const IdentityVerification = lazy(() => import('../containers/IdentityVerificationContainer'));
const UploadDocumentStepHeader = lazy(() => import('../components/UploadDocumentsStepHeader'));

export const VERIFICATION_STEPS_CLASSIC = [
  {
    key: 1,
    passed: false,
    title: 'profile:verification.personalDetails.title',
    contentComponent: VerificationPersonal,
    headerComponent: ProfileVerificationStepHeader,
    hasReadOnlyMode: false,
  },
  {
    key: 2,
    passed: false,
    title: 'profile:verification.accountSettings.title',
    subtitle: 'profile:verification.accountSettings.subtitle',
    contentComponent: AccountSettings,
    headerComponent: ProfileVerificationStepHeader,
    hasReadOnlyMode: true,
  },
  {
    key: 3,
    passed: false,
    title: 'profile:verification.identityVerification.title',
    contentComponent: IdentityVerification,
    headerComponent: UploadDocumentStepHeader,
    hasReadOnlyMode: false,
  },
  {
    key: 4,
    passed: false,
    title: 'profile:verification.additionalIdentityVerification.title',
    contentComponent: AdditionalIdentityVerification,
    headerComponent: UploadDocumentStepHeader,
    hasReadOnlyMode: false,
  },
];
